import React from 'react';
import styles from './CornerMarkers.module.css';

function CornerMarkers() {
  return (
    <div className={styles.root} aria-hidden="true">
      <span className={`${styles.mark} ${styles.tl}`}>+</span>
      <span className={`${styles.mark} ${styles.tr}`}>+</span>
      <span className={`${styles.mark} ${styles.bl}`}>+</span>
      <span className={`${styles.mark} ${styles.br}`}>+</span>
    </div>
  );
}

export default CornerMarkers;
